module.exports = __webpack_public_path__ + "img/a011_4.e9f02cfa.png";